import { GUID_REGEX } from "../../contexts/ScannerContext";

export interface TaggedRow {
  id: string;
  tagNumber?: string | null;
}

/**
 * Whether typed text is really a scanner burst that landed in the search box
 * (delimited label or bare GUID) rather than something a person typed.
 */
export function looksLikeScan(query: string): boolean {
  const q = query.trim();
  return q.includes("|") || q.includes("~") || GUID_REGEX.test(q);
}

/**
 * The single row whose tag equals the query (case-insensitive), or null when there is
 * none or more than one. Used on Enter so a typed tag adds straight to the basket.
 */
export function exactTagMatch<T extends TaggedRow>(rows: T[] | undefined, query: string): T | null {
  const q = query.trim().toLowerCase();
  if (!q || !rows) return null;

  const matches = rows.filter((r) => (r.tagNumber ?? "").trim().toLowerCase() === q);
  return matches.length === 1 ? matches[0] : null;
}
